import React from "react";
import PropTypes from "prop-types";
import "../style.scss";

/**
 * FrontLayer :
 * - FrontLayer for HexagonCard
 */
export function FrontLayer(props) {
  return (
    <>
      <div
        className={
          props.type === "OUTPUT_CARD" ? "hex_output_shape" : "hex_shape"
        }
      ></div>
    </>
  );
}

FrontLayer.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * Type of hexagon card
   */
  type: PropTypes.string,
};

FrontLayer.defaultProps = {
  className: "",
  type: "",
};
